import React from "react"

export const DisplayGenreIcon = (props) => {
    return (
        <div>{props.genres.map(genre => 
            <span key= {genre} title={genre}><img loading="lazy" className ='genre-icon' alt= {genre}src={`/images/genre-icons/${genre}.png`} style={props.style} /></span>)}
        </div>
    )
}